import { render, staticRenderFns } from "./individual_race_management.vue?vue&type=template&id=b5b460b8&scoped=true"
import script from "./individual_race_management.vue?vue&type=script&lang=js"
export * from "./individual_race_management.vue?vue&type=script&lang=js"
import style0 from "./individual_race_management.vue?vue&type=style&index=0&id=b5b460b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b460b8",
  null
  
)

export default component.exports